import React from "react";
import {
  BsFacebook,
  BsGithub,
  BsInstagram,
  BsLinkedin,
  BsTwitter,
} from "react-icons/bs";
import myimage from "../Images/myimage.png";
import { Link } from "react-router-dom";

const HomePort = ({ show, setShow }) => {
  return (
    <div className="row  overflow-hidden" id="Home" my-5>
      <div className="col-md-6  main_see">
        <h1 data-aos="fade-right" data-aos-duration="1000">
          Hi, I am <span onClick={() => setShow(!show)}> Hamza Farooq </span>
        </h1>
        <h2 data-aos-duration="1000" data-aos="fade-right">
          I am a <span>FrontEnd Developer </span>{" "}
        </h2>
        <p className="p" data-aos-duration="1000" data-aos="fade-right">
          I am presently employed as a Frontend Web Developer at Tech Creator
          Software House, specializing in crafting fully responsive websites. My
          enthusiasm lies in embracing new technologies, problem-solving, and
          collaborating with a professional team to explore fresh ideas and
          concepts.
        </p>
        <div
          className="iconmain"
          data-aos-duration="1000"
          data-aos="fade-down-left"
        >
          {/* <BsFacebook className="scialIcon" /> */}
          {/* <BsTwitter className="scialIcon" />
          <BsInstagram className="scialIcon" /> */}
          <a
            target="_blank" rel="noreferrer"
            href="https://web.facebook.com/profile.php?id=100015114696258"
          >
            {" "}
            <BsFacebook className="scialIcon" />
          </a>
          <a
            target="_blank" rel="noreferrer"
            href="https://www.linkedin.com/in/hamza-farooq-009673227/"
          >
            <BsLinkedin className="scialIcon" />
          </a>
          <a target="_blank" rel="noreferrer" href="https://github.com/Hamza607">
            {" "}
            <BsGithub className="scialIcon" />
          </a>
        </div>
      </div>
      <div className="col-md-6  main_see">
        <div
          className="image_div"
          data-aos-duration="1000"
          data-aos="fade-left"
        >
          <img src={myimage} className="myImagepro" alt="Remove the Cursor" />
        </div>
      </div>
    </div>
  );
};

export default HomePort;
